// extracted by mini-css-extract-plugin
module.exports = {"info-box":"InfoBox_info-box__7gO3S"};